module.exports = __webpack_public_path__ + "static/img/椭圆 1 拷贝 2.7658700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/椭圆 1 拷贝 2.png
// module id = 3ITZ
// module chunks = 1